import { render, staticRenderFns } from "./ItemizerCanvas.vue?vue&type=template&id=faf6b25e&"
import script from "./ItemizerCanvas.vue?vue&type=script&lang=js&"
export * from "./ItemizerCanvas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports